/**
 * Whether a conversation is waiting to be read, from one side's point of view.
 *
 * Its own module because both the list view and the bubble's provider need it,
 * and the list view already imports the provider — importing back would be a
 * cycle.
 */
import { FINISHED_SUPPORT_STATUSES, SupportTicket } from "../../api/support-tickets";

/** A message from the OTHER side newer than my side's watermark. */
export const hasUnseenReply = (ticket: SupportTicket, isStaff: boolean): boolean => {
	const seenAt = isStaff ? ticket.staff_seen_at : ticket.reporter_seen_at;
	const seen = seenAt ? Date.parse(seenAt) : null;
	return ticket.messages.some(
		(message) =>
			(isStaff ? message.is_from_reporter : !message.is_from_reporter) &&
			(seen === null || Date.parse(message.created) > seen)
	);
};

/**
 * Is this conversation waiting on US — an unseen reply in one that is still
 * going?
 *
 * A finished conversation owes nobody a reply: the reporter closed it, or an
 * operator did, and either way answering it makes no sense. It wears neither
 * the dot nor the bold, and the menu badge counts the same set (the queue's
 * unread_count endpoint).
 */
export const needsStaffAttention = (ticket: SupportTicket): boolean =>
	!FINISHED_SUPPORT_STATUSES.includes(ticket.effective_status) &&
	hasUnseenReply(ticket, true);
